export default __webpack_public_path__ + "static/media/arrow-down.930cce84.svg";